import React, { useEffect, useState } from 'react';
import { BellOff } from 'lucide-react';
import PromptCard from '../ui/PromptCard';
import PermissionRecoveryModal from './PermissionRecoveryModal';
import {
    getStoredBrowserState,
    shouldShowRecoveryBanner,
} from '../../lib/notificationPermission';

/**
 * Soft recovery prompt rendered on the dashboard when the user has
 * blocked notifications at the browser level AND it has been more than
 * 14 days since the denial. Dismissable for the session via the X — the
 * sessionStorage flag (`ethernal_recovery_dismissed`) keeps it out of
 * sight until next browser session, at which point it'll re-evaluate.
 *
 * The auto-detect on permission re-grant happens in authStore via
 * syncPermissionState, not here. This banner is just the nudge UI.
 */
const PermissionRecoveryBanner: React.FC = () => {
    const [show, setShow] = useState(false);
    const [modalOpen, setModalOpen] = useState(false);

    useEffect(() => {
        let cancelled = false;
        (async () => {
            const state = await getStoredBrowserState();
            if (cancelled) return;
            if (state && shouldShowRecoveryBanner(state)) {
                setShow(true);
            }
        })();
        return () => {
            cancelled = true;
        };
    }, []);

    const handleDismiss = () => {
        try {
            sessionStorage.setItem('ethernal_recovery_dismissed', 'true');
        } catch {
            // sessionStorage unavailable — ignore.
        }
        setShow(false);
    };

    if (!show) return null;

    return (
        <>
            <PromptCard
                icon={BellOff}
                headline="Avisos del móvil bloqueados"
                body="Si los activas, te llegan al instante en lugar de por correo."
                cta={{
                    label: 'Cómo activarlos',
                    onClick: () => setModalOpen(true),
                }}
                onDismiss={handleDismiss}
            />
            <PermissionRecoveryModal
                open={modalOpen}
                onClose={() => setModalOpen(false)}
            />
        </>
    );
};

export default PermissionRecoveryBanner;
